import Resources from '../../helpers/resources';
import { handleResourceError, handleResourceSuccess } from '../../helpers/resource-handlers';
import { formatDate, getDownloadUrl } from '../../helpers/utils';
import { DOWNLOAD_PARTICIPATION_REPORT_URL } from './participation-report-constants';
import { DOWNLOAD_SERVICE_IS_ACTIVE } from '../certificates/download-certificates-actions';
import fetcherZip from '../../helpers/fetcher-zip';

export const PARTICIPATION_REPORT_RETRIEVED = 'PARTICIPATION_REPORT_RETRIEVED';

function getParticipationReport({ productId, profileId, schoolId, classroomId, startDate, endDate, academicYear }) {
    return dispatch => Resources
        .participationReport
        .get({ profileId })
        .withParams({ productId, schoolId, classroomId, startDate, endDate, academicYear })
        .send()
        .then(
            (payload) => {
                const reportData = payload.data;
                if (reportData) {
                    const {
                        newCertificateSummary,
                        studentCertificateInfo,
                        courseResult,
                        liveMathsResult,
                        questCourseResult,
                        newCourseResult,
                        challengesResult
                    } = reportData;

                    return handleResourceSuccess(dispatch, payload, {
                        type: PARTICIPATION_REPORT_RETRIEVED,
                        payload: {
                            ...reportData,
                            newCertificateSummary: onlyRanksFromList(newCertificateSummary),
                            pastCertificateSummary: mapStudentAwards(studentCertificateInfo,
                                courseResult),
                            courseResult: mapCourseResults(courseResult),
                            liveMathsResult: mapLiveMathsResult(liveMathsResult),
                            questCourseResult: mapQuestCourseResult(questCourseResult),
                            newCoursesResult: mapNewCoursesResult(newCourseResult),
                            challengesResult: mapChallengesResult(challengesResult)
                        }
                    });
                }
                return handleResourceError(dispatch, payload.message);
            },
            error => handleResourceError(dispatch, error)
        );
}

function onlyRanksFromList(newCertificateSummary) {
    if (newCertificateSummary) {
        delete newCertificateSummary.total;
    }
    return newCertificateSummary;
}
function mapStudentAwards(studentCertificateInfo, courseResult) {
    if (!studentCertificateInfo || !courseResult) {
        return null;
    }

    const {
        bronze: bronzePast,
        silver: silverPast,
        gold: goldPast
    } = studentCertificateInfo;
    return {
        bronzePast,
        silverPast,
        goldPast,
        goldBarsPast: courseResult.goldBars
    };
}

function mapCourseResults(courseResult) {
    if (!courseResult || !courseResult.courses) {
        return null;
    }

    return {
        ...courseResult,
        courses: courseResult.courses.map((course) => {
            const mappedActivities = course.allActivities.map((activity, idx) => ({
                ...activity,
                id: `${activity.id}-${idx}`,
                result: `${activity.result}%`,
                completionDate: activity.completionDate ? formatDate(activity.completionDate) : '-'
            }));

            return {
                courseName: course.courseName,
                allActivities: mappedActivities,
                averageResult: `Avg. ${course.averageResult}%`,
                totalPoints: `Total ${course.totalPoints}`
            };
        })
    };
}

function mapLiveMathsResult(liveMathsResult) {
    if (!liveMathsResult) {
        return null;
    }

    const mappedLiveMathsInfo = liveMathsResult.liveMathsInfo.map(item => ({
        id: item.level,
        level: item.level,
        correct: formatScore(item.correct, item.hasValue),
        points: formatScore(item.points, item.hasValue),
        accuracy: formatScore(item.accuracy, item.hasValue, '%')
    }));

    return {
        liveMathsInfo: mappedLiveMathsInfo,
        maxLiveMathsLevels: `Maximum ${liveMathsResult.maxLiveMathsLevels} levels`,
        averageCorrect: `Avg. ${liveMathsResult.averageCorrect}%`,
        totalPoints: `Total ${liveMathsResult.totalPoints}`
    };
}

function mapQuestCourseResult(questCourseResult) {
    return questCourseResult.map((course) => {
        course.averageAccuracy = `Avg. ${course.averageAccuracy}%`;
        course.allActivities.map((activity) => {
            activity.completionDate = formatDate(activity.completionDate);
            activity.accuracy = `${activity.accuracy}%`;
            return activity;
        });

        return course;
    });
}
function mapNewCoursesResult(newCourseResult) {
    return newCourseResult.map((course) => {
        course.courseResults.map((activity) => {
            activity.completionDate = formatDate(activity.completionDate);
            activity.accuracy = `${activity.accuracy}%`;
            return activity;
        });
        course.averageResult = `Avg. ${course.averageAccuracy}%`;
        course.totalPoints = `Total ${course.totalPoints}`;
        return course;
    });
}

function mapChallengesResult(challengesResult) {
    if (!challengesResult || !challengesResult.challenges) {
        return null;
    }

    return {
        challenges: challengesResult.challenges.map(challenge => ({
            ...challenge,
            id: challenge.name,
            completionDate: formatDate(challenge.completionDate),
            accuracy: `${challenge.accuracy}%`
        })),
        averageResult: `Avg. ${challengesResult.averageAccuracy}%`,
        totalPoints: `Total ${challengesResult.totalPoints}`
    };
}

function formatScore(score, hasValue, suffix) {
    if (score || score === 0 && hasValue) {
        if (suffix) {
            return `${score}${suffix}`;
        }
        return `${score}`;
    }

    return '-';
}

function downloadServiceIsActive({ isActive, dispatch }) {
    dispatch({
        type: DOWNLOAD_SERVICE_IS_ACTIVE,
        payload: {
            isActive
        }
    });
}
/*
* Downloads participation report for entire class
*/
async function downloadParticipationReport({
    paramData
}) {
    const url = await getDownloadUrl({
        resourceUrl: DOWNLOAD_PARTICIPATION_REPORT_URL,
        paramData,
        dateFormat: 'MM-DD-YYYY'
    });

    return (dispatch) => {
        downloadServiceIsActive({
            isActive: true,
            dispatch
        });
        return fetcherZip(url)
            .then(() => {
                downloadServiceIsActive({
                    isActive: false,
                    dispatch
                });
            })
            .catch((err) => {
                handleResourceError(dispatch, err, 'downloadAllClassPastCerts');
                downloadServiceIsActive({
                    isActive: false,
                    dispatch
                });
            });
    };
}


export default {
    getParticipationReport,
    downloadParticipationReport
};



// WEBPACK FOOTER //
// ./containers/participation-report/participation-report-actions.js